import { ref } from 'vue'

export interface Toast {
  id: number
  message: string
  type: 'success' | 'error' | 'info' | 'warning'
}

const toasts = ref<Toast[]>([])
let nextId = 0

export function useToast() {
  function addToast(message: string, type: Toast['type'] = 'info', duration = 4000) {
    const id = nextId++
    toasts.value.push({ id, message, type })

    if (duration > 0) {
      setTimeout(() => removeToast(id), duration)
    }
  }

  function removeToast(id: number) {
    toasts.value = toasts.value.filter(t => t.id !== id)
  }

  function success(message: string, duration?: number) {
    addToast(message, 'success', duration)
  }

  function error(message: string, duration?: number) {
    addToast(message, 'error', duration)
  }

  function info(message: string, duration?: number) {
    addToast(message, 'info', duration)
  }

  function warning(message: string, duration?: number) {
    addToast(message, 'warning', duration)
  }

  return { toasts, addToast, removeToast, success, error, info, warning }
}
